import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import * as API from '../../Endpoints/Endpoints';

const UpdateChariot = ({ type }) => {
  const { globalid, chariotid } = useParams();
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const apiUrl =
      type === 'global'
        ? API.GET_GLOBAL_ETHICS_BYID(globalid)
        : API.GET_AI_CHARIOT_BYID(chariotid);

    axios
      .get(apiUrl)
      .then((res) => {
        setFormData(res.data);
      })
      .catch((err) => alert('Fetch error: ' + err));
  }, [type, globalid, chariotid]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const apiUrl =
      type === 'global'
        ? API.PUT_GLOBAL_API(globalid)
        : API.PUT_AICHARIOT_API(chariotid);
  
    axios
      .put(apiUrl, formData)
      .then(() => {
        alert('Updated successfully');
        // 👇 Navigate based on type
        if (type === 'global') {
          navigate('/chariottable'); 
        }
      })
      .catch((err) => alert('Update error: ' + err));
  };
  
  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h2 className="text-xl font-bold mb-4">
        Update {type === 'global' ? 'Global Ethics' : 'AI Career Chariot'}
      </h2>

      <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input
          name="chariotname"
          value={formData.chariotname || ''}
          onChange={handleChange}
          placeholder="Chariot Name"
          className="border p-2"
        />
        <input
          name="theme"
          value={formData.theme || ''}
          onChange={handleChange}
          placeholder="Theme"
          className="border p-2"
        />

        {type === 'global' && (
          <>
            <input
              name="religion"
              value={formData.religion || ''}
              onChange={handleChange}
              placeholder="Religion"
              className="border p-2"
            />
            <input
              name="religiousquote"
              value={formData.religiousquote || ''}
              onChange={handleChange}
              placeholder="Religious Quote"
              className="border p-2"
            />
          </>
        )}

        {type === 'chariot' && (
          <>
            <input
              name="aicareerrole"
              value={formData.aicareerrole || ''}
              onChange={handleChange}
              placeholder="AI Career Role"
              className="border p-2"
            />
            <input
              name="aiinsight"
              value={formData.aiinsight || ''}
              onChange={handleChange}
              placeholder="AI Insight"
              className="border p-2"
            />
          </>
        )}

        <input
          name="wheelnumber"
          value={formData.wheelnumber || ''}
          onChange={handleChange}
          placeholder="Wheel Number"
          className="border p-2"
        />
        <input
          name="wheelname"
          value={formData.wheelname || ''}
          onChange={handleChange}
          placeholder="Wheel Name"
          className="border p-2"
        />
        <input
          name="moralsciencequestion"
          value={formData.moralsciencequestion || ''}
          onChange={handleChange}
          placeholder="Moral Science Question"
          className="border p-2"
        />
        <input
          name="agegroup"
          value={formData.agegroup || ''}
          onChange={handleChange}
          placeholder="Age Group"
          className="border p-2"
        />
        <input
          name="standard"
          value={formData.standard || ''}
          onChange={handleChange}
          placeholder="Standard"
          className="border p-2"
        />

        <div className="md:col-span-2">
          <button
            type="button"
            onClick={handleSubmit}
            className="bg-[#e64a32] text-white px-4 py-2 mt-2 w-full"
          >
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateChariot;
